import { render, staticRenderFns } from "./Activitydetail.vue?vue&type=template&id=70e6855a&scoped=true&"
import script from "./Activitydetail.vue?vue&type=script&lang=js&"
export * from "./Activitydetail.vue?vue&type=script&lang=js&"
import style0 from "./Activitydetail.vue?vue&type=style&index=0&id=70e6855a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e6855a",
  null
  
)

export default component.exports